import {forwardRef} from 'react'
import useOutsideClick from '../../hooks/use_outside_click'

export const ClickOutsideManager = forwardRef(({onClick, opts}, ref) => {
  useOutsideClick(ref, onClick, opts)
  return null
})
